import cx from 'classnames'
import type { ElementType, JSX } from 'react'

import {
  type PropsWithSafeExtra,
  safeRestProps,
} from '../../libs/safeRestProps'
import { spacingStyles } from '../../libs/spacingStyles'

type Props = PropsWithSafeExtra<
  'div',
  'className' | 'children' | 'style' | 'inert',
  Parameters<typeof spacingStyles>[0] & {
    as?: keyof Pick<JSX.IntrinsicElements, 'div' | 'ul' | 'ol'>
  }
>

/**
 * Stack is a deliberately simple layout component that applies 'flex', gap, and padding which is 0 by default.
 *
 * @description Use tailwind classes to control other flex properties which aren't exposed here as to not reinvent the wheel.
 */
export const Stack = ({
  children,
  className,
  gap,
  padding,
  as: Component = 'div',
  extraProps = {},
  ...restProps
}: Props) => {
  const Comp = Component as ElementType
  return (
    <Comp
      {...safeRestProps(extraProps, restProps)}
      className={cx('flex', spacingStyles({ gap, padding }), className)}
    >
      {children}
    </Comp>
  )
}
